import {useSelector} from "react-redux";

export const useStripeGuard = (route) => {
    const user = useSelector(state => state.users.user)
    return user &&
        user.stripe_subscriptions_natives &&
        user.stripe_subscriptions_natives.length > 0;
}
